<template>
<div>
  <div class="flex justify-between">
    <div class="mt-4 w-1/4">
      <vs-button color="primary" type="filled" @click="$emit('create-form')"
                 icon="control_point">
        {{ $t('message.salaryProject.addEmployee') }}
      </vs-button>
    </div>
    <div class="mt-4 w-2/3 text-right leading-form">
      <vs-button @click="getByStatus(null)" line-origin="center"
                 color="primary" type="flat" class="mr-2">
        {{ $t('message.salaryProject.empAll') }}
      </vs-button>
      <vs-button @click="getByStatus(0)" line-origin="center"
                 color="primary" type="flat" class="mr-2">
        {{ $tc('message.salaryProject.employeesStatus', 0) }}
      </vs-button>
      <vs-button @click="getByStatus(1)" line-origin="center"
                 color="primary" type="flat" class="mr-2">
        {{ $tc('message.salaryProject.employeesStatus', 1) }}
      </vs-button>
    </div>
  </div>
  <vs-table
    stripe :data="employees" pagination :maxItems="10"
    class="w-full mt-4"
    :noDataText="$t('message.salaryProject.noDataText')">
    <template slot="thead">
      <vs-th>{{ $t('message.salaryProject.tableHeaderFio') }}</vs-th>
      <vs-th>{{ $t('message.salaryProject.tableHeaderPost') }}</vs-th>
      <vs-th>{{ $t('message.salaryProject.tableHeaderMain') }}</vs-th>
      <vs-th>{{ $t('message.salaryProject.tableHeaderStatus') }}</vs-th>
      <vs-th>{{ $t('message.salaryProject.tableHeaderActions') }}</vs-th>
    </template>
    <template :slot-scope="{employees}">
      <template  v-for="row in employees">
        <vs-tr :key="row.id">
          <vs-td>{{ row.tp_name }}</vs-td>
          <vs-td>{{ row.tp_position }}</vs-td>
          <vs-td>{{ row.account_numb }} {{ row.card_numb }}</vs-td>
          <vs-td>{{ $tc('message.salaryProject.employeesStatus', row.status) }}</vs-td>
          <vs-td>
            <vs-button color="primary" class="inline-block mr-2" type="border" icon="edit" @click="editClick(row)" />
            <vs-button color="primary" class="inline-block mr-2" type="border" icon="get_app" v-if="false" />
            <vs-button color="primary" class="inline-block" type="border" icon="print" v-if="false" />
         </vs-td>
        </vs-tr>
      </template>
    </template>
  </vs-table>
</div>
</template>

<script>
export default {
  name: 'EmployeesTable',
  props: ['employees'],
  methods: {
    setSelected (val) {
      this.$emit('set-selected', val)
    },
    editClick (data) {
      this.$emit('edit-data', data)
    },
    getByStatus (status) {
      this.$emit('get-status', status)
    }
  }
}
</script>

<style scoped>

</style>
